// extracted by mini-css-extract-plugin
export var productBottomBar = "bottomBar-module--product-bottom-bar--tmv9h";
export var isScrolled = "bottomBar-module--is-scrolled--rp2VD";